// import React from "react";
// import "./CircularLoader.css";
// import logo from "../../../assets/logo/vertex-logo-animation.gif";
// const CircularLoader = ({ classes, classloader }) => {
//   return (
//     <div className={classes}>
//       {/* <div className={classloader}> */}
//       {/* </div> */}
//       <img className="w-1/2" src={logo} alt="vertex-logo" />
//     </div>
//   );
// };

// export default CircularLoader;


import React from "react";
import "./CircularLoader.css";
import logo from "../../../assets/logo/vertex-logo-animation.gif";

const CircularLoader = ({ classes, width_size='w-1/2' }) => {
  return (
    <div className={`flex justify-center items-center ${classes}`}>
      <img className={`${width_size}`} src={logo} alt="Vertex360" />
    </div>
  );
};

export default CircularLoader;
